import zeroCodeProviders from "@/config/zeroCodeProviders";

export function getCancellationLastDate(variant, locale) {
    if (!locale || !variant || Object.keys(variant).length === 0) return ""
    
    const zeroCode = variant.zeroCode
    const zeroCodeProvider = parseInt(zeroCode.split("#")[0])
    const cancellationPeriod = zeroCodeProviders[zeroCodeProvider]['cancellationPeriod']
    const startDate = new Date(variant.startDate);
    const cancellationLastDate = new Date(startDate.getTime() - cancellationPeriod*24*60*60*1000);
    return cancellationLastDate.toLocaleDateString(locale.indexOf("_")!==-1 ? locale.replace("_","-") : locale);
  }
  
  